import { ApiResponseServingData } from "../@types";

export class ApiResponseError extends Error {
  info: {
    requestId?: string | null;
    anonymousSessionId?: string | null;
    beneSessionId?: string | null;
    apiResponseStatus?: number;
    apiResponseStatusText?: string | null;
    apiRequestUrl?: string | null;
    apiRequestBody?: string | null;
    apiError?: string | null;
    apiErrorMessage?: string | null;
    apiErrorCode?: number;
    apiResponseDetails?: ApiResponseServingData | null | string;
  };

  constructor(name?: string, message?: string) {
    super(message);
    this.name = name ?? "ApiResponseError";
    this.info = {};
  }
}

function isApiResponseError(
  err: Error | ApiResponseError
): err is ApiResponseError {
  return "info" in err;
}

// Build an an error object and log to new relic
export function logError(message: string, err: Error | ApiResponseError): void {
  const { newrelic } = window;

  // Wrap the error message with the app message
  err.message = `${message}: ${err.message}`;

  if (newrelic) {
    if (isApiResponseError(err)) {
      newrelic.noticeError(err, err.info);
    } else {
      newrelic.noticeError(err);
    }
  }
}
